import React from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useQueries, useQuery } from "@tanstack/react-query";
import { getScheduleData, getScheduleDays } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import SessionScheduleTable from "components/common/schedule/SessionScheduleTable";
import { ALL_URL, groupByDate } from "helpers/utils";
import { useGetConfigSports } from "helpers/commonCodes";
import DateScheduleTable from "components/common/schedule/DateScheduleTable";
import { useSelector } from "react-redux";
import useViewport from "components/general/useViewPort";
import SelectorDay from "components/common/selector-day/SelectorDay";
import DayList from 'components/common/selector-day/Day';
import { getEventRSC } from "helpers/rsc";
import SelectorTimeZone from "components/common/selectors/selector-timezone";
import { LegendProvider } from "components/common/legendContext";
import { CleanLegends } from "components/common/CleanLegends";
import { LegendsBox } from "components/common/LegendsBox";
import Label from 'components/general/Label';


const ScheduleDisciplineAndDate = () => {
  const { mirs_competition, mirs_language, mirs_date, mirs_discipline, mirs_event } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();
  const dataConfigSport = useGetConfigSports({ mirs_competition, mirs_discipline });
  const timeZone = useSelector((state) => state.appGlobal.timezone);

  const isH2H = dataConfigSport?.isH2H;

  const { data: daysData, isError: isErrorScheduleDays, isLoading: isLoadingScheduleDays, isSuccess: isSuccessScheduleDays } = useQuery(
    {
      queryKey: ['scheduleDays', mirs_competition, mirs_language, mirs_discipline],
      queryFn: getScheduleDays,
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      cacheTime: 300000,
      staleTime: 20000,
      suspense: false,
      notifyOnChangeProps: ['data', 'error']
    });

  let queryArray = [];
  daysData?.competition_schedule?.forEach((item) => {
    queryArray.push({
      queryKey: ['scheduleData', mirs_competition, mirs_language, mirs_discipline, item.date, mirs_event, isH2H],
      queryFn: getScheduleData,
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
    });
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const results = useQueries({ queries: queryArray });
  const isLoading = isLoadingScheduleDays || results.some(result => result.isLoading)
  const isError = isErrorScheduleDays || results.some(result => result.isError)
  const allSuccess = isSuccessScheduleDays && results.every(result => result.isSuccess === true)

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader /> }
  if (allSuccess) {
    let items = []
    results && results.forEach((item) => {
      const data = item.data.filter((u) => u?.eventUnit?.phase?.type?.match('[13]'));
      items.push(...data);
    });

    //filters by event
    if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
      items = items?.filter(row => row?.eventUnit?.phase?.event?.code === getEventRSC(mirs_event));
    };

    let dates = groupByDate(items, 'startDate', timeZone);
    let itemsDates = { competition_schedule: [] };
    for (const key in dates) {
      itemsDates.competition_schedule.push({ date: key });
    };

    const todaySchedule = dates?.[mirs_date];
    const eventorder = todaySchedule?.[0]?.discipline?.eventorder;
    let schedule = null;

    if (todaySchedule?.length > 0) {
      switch (eventorder) {
        case 'DATE':
        case 'LOC':
          schedule = <DateScheduleTable data={todaySchedule} eventorder={eventorder} isH2H={isH2H} />
          break;
        case 'SESSION':
          schedule = <SessionScheduleTable data={todaySchedule} isH2H={isH2H} />
          break;
        default:
          schedule = <DateScheduleTable data={todaySchedule} eventorder={eventorder} isH2H={isH2H} />
          break;
      }
    } else {
      schedule = null;
    }



    return <>

      <nav className="selectors-container" direction={breakPoint === "md" || breakPoint === "sm" || breakPoint === "xs" ? "horizontal" : "vertical"} aria-labelledby="NavScheduleDisciplineDate">
        <span id="NavScheduleDisciplineDate" className="d-none"><Label data="LabelScheduleDateDiscNav" /></span>
        {
          (breakPoint === "md" || breakPoint === "sm" || breakPoint === "xs")
            ? <>
              <SelectorTimeZone />
              <SelectorDay daysItems={itemsDates} />
            </>
            : <>
              <DayList daysItems={itemsDates} />
              <div className="d-flex justify-content-end">
                <SelectorTimeZone />
              </div>
            </>
        }
        {/**
        <div className="d-flex">
          <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="schedule" discArray={allSportsInThisDay} />
          <SelectorEvent page='schedule' />
        </div>
         */}
      </nav>
      <LegendProvider >
        <CleanLegends />
        {schedule}
        <LegendsBox />
      </LegendProvider>

    </>;

  };
}

export default ScheduleDisciplineAndDate;
